import React from "react";
import {Box, CircularProgress, colors, IconButton, makeStyles} from "@material-ui/core";

import { FormattedMessage, useIntl } from "react-intl";
import ExpandMoreOutlined from "@material-ui/icons/ExpandMore";
import { CustomTooltip } from "./Tooltip";

const useStyles = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    paddingTop: theme.spacing(0.6),
    paddingBottom: theme.spacing(0.6),
  },
  actions: {},
  actionsPrev: {
    transform: "rotate(90deg)",
    marginLeft: "auto",
    marginRight: 4,
    color: colors.grey[700],
  },
  actionsNext: {
    transform: "rotate(-90deg)",
    marginLeft: "auto",
    color: colors.grey[700],
  },
  titles: {
    fontSize: "0.88rem",
    color: colors.grey[700],
    marginRight: 14,
  },
  loading: {
    width: "30px",
    display: "flex",
    alignItems: "center"
  }
}));

export interface PaginationActionsProps extends React.HTMLAttributes<HTMLDivElement> {
  loading?: boolean;
  enabled?: boolean;
  totalPages: number;
  perPage: number;
  pageNumber: number;

  handlePrevAction?: () => void | null;
  handleNextAction?: () => void | null;
}

const DynamicPaginationActions = (props: PaginationActionsProps) => {
  const classes = useStyles();
  const intl = useIntl();
  const {loading, totalPages, perPage, pageNumber, enabled, handlePrevAction, handleNextAction}  = props;

  const handleBackButtonClick = (event: any) => {
    handlePrevAction();
  };

  const handleNextButtonClick = (event: any) => {
    handleNextAction();
  };

  let pageVisited = perPage * (pageNumber - 1);
  return (
    <Box
      component="div"
      display="flex"
      alignItems="center"
      justifyContent="end"
      className={classes.root}
    >
      <Box component="div">
        <Box component="div" className={classes.titles}>
          <FormattedMessage
            id="sharedScreen.dynamicPaginatorTitles"
            values={{
              pageVisited: pageVisited + 1,
              totalPageVisited: pageVisited + perPage,
              totalPages: totalPages
            }}
          />
        </Box>
      </Box>
      <Box className={classes.actions}>
        <CustomTooltip
          title={intl.formatMessage({ id: "sharedScreen.prev" })}
          arrow
        >
          <IconButton
            className={classes.actionsPrev}
            onClick={handleBackButtonClick}
            disabled={!enabled || handlePrevAction === null || handlePrevAction === undefined}
          >
            <ExpandMoreOutlined
              fontSize="small"
              titleAccess={intl.formatMessage({
                id: "sharedScreen.previous",
              })}
            />
          </IconButton>
        </CustomTooltip>

        <CustomTooltip
          title={intl.formatMessage({ id: "sharedScreen.next" })}
          arrow
        >
          <IconButton
            onClick={handleNextButtonClick}
            className={classes.actionsNext}
            disabled={!enabled || handleNextAction === null || handleNextAction === undefined}
          >
            <ExpandMoreOutlined
              fontSize="small"
              titleAccess={intl.formatMessage({ id: "sharedScreen.next" })}
            />
          </IconButton>
        </CustomTooltip>
      </Box>
      {
        loading ? (
            <Box className={classes.loading}>
              <CircularProgress color="secondary" disableShrink={false} size={16} thickness={4}/>
            </Box>
        ) : (<></>)
      }
    </Box>
  );
};

DynamicPaginationActions.defaulProps = {
  loading: false,
  enabled: true,
};

export default DynamicPaginationActions;
